import { Button, CircularProgress, Grid, TextField, Typography } from '@mui/material';
import { useFormik } from 'formik';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Layout, Loading, UserNavbar } from '../../../components';
import SimpleCard from '../../../components/SimpleCard';
import { systemParametersValidations } from './validations';
import { getSystemParameters, saveSystemParameters } from '../../../core/system-parameters/action';

const initialFormValues = {
  booking_fee_percentage: '',
  cancellation_fee_percentage: '',
  admin_email: '',
  retail_booking_fee_percentage: '',
  retail_cancellation_fee_percentage: '',
};

export default function SystemParameters() {
  const { loading, currentSystemParameters } = useSelector((store) => store.systemParameters);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSystemParameters());
  }, [dispatch]);

  const formik = useFormik({
    initialValues: initialFormValues,
    validationSchema: systemParametersValidations,
    onSubmit: (values) => {
      dispatch(
        saveSystemParameters({
          ...values,
          booking_fee_percentage: Number(values.booking_fee_percentage),
          cancellation_fee_percentage: Number(values.cancellation_fee_percentage),
          retail_booking_fee_percentage: Number(values.retail_booking_fee_percentage),
          retail_cancellation_fee_percentage: Number(values.retail_cancellation_fee_percentage),
          admin_email: values.admin_email,
          // eslint-disable-next-line prettier/prettier
        })
      );
    },
  });

  useEffect(() => {
    if (currentSystemParameters) {
      formik.setValues(currentSystemParameters);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSystemParameters]);

  return (
    <Layout>
      {loading && <Loading />}
      <UserNavbar />
      <Grid container marginTop={9} justifyContent="center">
        <Grid item xs={12} md={6} lg={4}>
          <SimpleCard variant="outlined">
            <div style={{ marginBottom: '1rem' }}>
              <Typography fontWeight="bold">System parameters</Typography>
            </div>
            <form onSubmit={formik.handleSubmit}>
              <TextField
                type="number"
                style={{ marginBottom: '1rem' }}
                fullWidth
                label="Booking fee percentage"
                name="booking_fee_percentage"
                value={formik.values.booking_fee_percentage || ''}
                onChange={formik.handleChange}
                variant="standard"
                size="small"
                error={
                  formik.touched.booking_fee_percentage &&
                  Boolean(formik.errors.booking_fee_percentage)
                }
                helperText={
                  formik.touched.booking_fee_percentage && formik.errors.booking_fee_percentage
                }
              />
              <TextField
                type="number"
                style={{ marginBottom: '1rem' }}
                fullWidth
                label="Cancellation fee percentage"
                name="cancellation_fee_percentage"
                value={formik.values.cancellation_fee_percentage || ''}
                onChange={formik.handleChange}
                variant="standard"
                size="small"
                error={
                  formik.touched.cancellation_fee_percentage &&
                  Boolean(formik.errors.cancellation_fee_percentage)
                }
                helperText={
                  formik.touched.cancellation_fee_percentage &&
                  formik.errors.cancellation_fee_percentage
                }
              />
              <TextField
                style={{ marginBottom: '1rem' }}
                fullWidth
                label="Admin email"
                name="admin_email"
                value={formik.values.admin_email || ''}
                onChange={formik.handleChange}
                variant="standard"
                size="small"
                error={formik.touched.admin_email && Boolean(formik.errors.admin_email)}
                helperText={formik.touched.admin_email && formik.errors.admin_email}
              />
              <TextField
                type="number"
                style={{ marginBottom: '1rem' }}
                fullWidth
                label="Retail booking fee percentage"
                name="retail_booking_fee_percentage"
                value={formik.values.retail_booking_fee_percentage || ''}
                onChange={formik.handleChange}
                variant="standard"
                size="small"
                error={
                  formik.touched.retail_booking_fee_percentage &&
                  Boolean(formik.errors.retail_booking_fee_percentage)
                }
                helperText={
                  formik.touched.retail_booking_fee_percentage &&
                  formik.errors.retail_booking_fee_percentage
                }
              />
              <TextField
                type="number"
                style={{ marginBottom: '1rem' }}
                fullWidth
                label="Retail cancellation fee percentage"
                name="retail_cancellation_fee_percentage"
                value={formik.values.retail_cancellation_fee_percentage || ''}
                onChange={formik.handleChange}
                variant="standard"
                size="small"
                error={
                  formik.touched.retail_cancellation_fee_percentage &&
                  Boolean(formik.errors.retail_cancellation_fee_percentage)
                }
                helperText={
                  formik.touched.retail_cancellation_fee_percentage &&
                  formik.errors.retail_cancellation_fee_percentage
                }
              />
              <Button type="submit" disabled={loading}>
                {loading ? <CircularProgress size={20} /> : 'Save'}
              </Button>
            </form>
          </SimpleCard>
        </Grid>
      </Grid>
    </Layout>
  );
}
